import { Card } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import PublicContent from '@/components/content-list/public-content';

export default function PublicContentList() {
  const { referenceId } = useParams<{
    referenceId: string;
  }>();

  return (
    <Card.Root minH={'100vh'} mx={'auto'} maxW={'3xl'}>
      <Card.Body>
        {referenceId && <PublicContent referenceId={referenceId} hasHeader={true} />}
      </Card.Body>
    </Card.Root>
  );
}
